import Cookie from 'universal-cookie';
import * as speechSDK from 'microsoft-cognitiveservices-speech-sdk';

export default class ScribeServices {
  constructor(axios) {
    this.axios = axios;
  }

  async getOrCreateSession(siteId, mkey) {
    const res = await this.axios.post('/v1/private/scribe/session', { siteId, mkey });
    return res.data;
  }

  async saveTranscript(siteId, mkey, transcript) {
    const res = await this.axios.patch('/v1/private/scribe/session', { siteId, mkey, transcript });
    return res.data;
  }

  async generateNote(siteId, mkey, intakeReport, verbosity, noteTemplate) {
    const res = await this.axios.post('/v1/private/scribe/note', {
      siteId, mkey, intakeReport, verbosity, noteTemplate,
    });
    return res.data;
  }

  async getSpeechToken() {
    const cookie = new Cookie();
    const cached = cookie.get('speech-token');
    if (cached) {
      const idx = cached.indexOf(':');
      return { authToken: cached.slice(idx + 1), region: cached.slice(0, idx) };
    }
    const res = await this.axios.post('/v1/private/getSpeechToken');
    const { token, region } = res.data;
    cookie.set('speech-token', `${region}:${token}`, { maxAge: 540, path: '/' });
    return { authToken: token, region };
  }

  async createTranscriber(language = 'en-US') {
    const { authToken, region } = await this.getSpeechToken();
    const config = speechSDK.SpeechConfig.fromAuthorizationToken(authToken, region);
    config.speechRecognitionLanguage = language;
    const audio = speechSDK.AudioConfig.fromDefaultMicrophoneInput();
    return new speechSDK.ConversationTranscriber(config, audio);
  }
}
